import { isDefined } from '@stillmandigital/common';
import BigNumber from 'bignumber.js';

export const MULTIPLIER = 100;

export function toViewReferralAgentRateValue<T extends number | undefined>(
  rate: T,
  multiplier = MULTIPLIER,
): typeof rate {
  if (isDefined(rate)) {
    return new BigNumber(rate).times(multiplier).toNumber() as NonNullable<T>;
  }
  return rate;
}

export function toApiReferralAgentRateValue<T extends number | undefined>(
  rate: T,
  multiplier = MULTIPLIER,
): typeof rate {
  if (isDefined(rate)) {
    return new BigNumber(rate).dividedBy(multiplier).toNumber() as NonNullable<T>;
  }
  return rate;
}
